import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';
import { useAvailabilityWatchListener } from '../hooks/useAvailabilityWatchListener';
import { useSelfAvailabilityToast } from '../hooks/useSelfAvailabilityToast';

interface AvailabilityWatchCtxValue {
  pendingCount: number;
}

const AvailabilityWatchContext = createContext<AvailabilityWatchCtxValue>({ pendingCount: 0 });

export function AvailabilityWatchProvider({ children }: { children: ReactNode }) {
  const [pendingCount, setPendingCount] = useState(0);

  const handleUserWaiting = useCallback((count: number) => {
    setPendingCount(count);
  }, []);

  useAvailabilityWatchListener({ onUserWaiting: handleUserWaiting });
  useSelfAvailabilityToast();

  return (
    <AvailabilityWatchContext.Provider value={{ pendingCount }}>
      {children}
    </AvailabilityWatchContext.Provider>
  );
}

export function useAvailabilityWatchContext(): AvailabilityWatchCtxValue {
  return useContext(AvailabilityWatchContext);
}
